import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import {
    AuthorizationSelectors,
    CoreSelectors,
    ModulesSelectors,
    SosLoaderService,
} from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'serviceos-web-recover-password-screen',
    templateUrl: './recover-password-screen.component.html',
    styleUrls: ['./recover-password-screen.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RecoverPasswordScreenComponent implements OnInit {

    @Select(ModulesSelectors.getImageFromModule('auth', 'auth_page_background'))
    authPageBackground$!: Observable<string>;
    
    public screen = 'recover-password';

    private subscriptions: Subscription[] = [];
    public isCoreInit = false;
    public isUserAuthorized = true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _loaderService: SosLoaderService,
        private store: Store
    ) {}

    ngOnInit(): void {
        const loader = this._loaderService.showLoader();

        this.subscriptions.push(
            this.store
                .select(CoreSelectors.completeInitialize)
                .subscribe((result) => {
                    this._loaderService.hideLoader(loader);
                    this.isCoreInit = !!result;
                })
        );

        this.subscriptions.push(
            this.store
                .select(AuthorizationSelectors.getAuthorization)
                .subscribe((data) => {
                    if (data) {
                        if (data.sid) {
                            this.router.navigate(['']);
                        } else {
                            this.isUserAuthorized = false;
                        }
                    }
                })
        );
    }

    public onChangeScreen(screen) {
        this.router.navigate(['/auth/' + screen], { relativeTo: this.route });
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }
}
